import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import { FileUploadResponseItem } from './types';

export const uploadFile = (data: FormData, isNotCancel = true) => {
  return http.post<FileUploadResponseItem[]>({
    url: '/communal/file/upload',
    data,
    isNotCancel,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 获取 获取省市区数据
 * @param {*} params
 * @returns
 */

export const getAreaTree = (params: any) => {
  const url = '/ufg/web/v1/area/queryAllAreas';

  return http.get({
    url,
    params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
